import { Meta, theme } from 'aimo-ui';
import { ImportantZoneNotes } from 'components/park/ParkingZoneNotes';
import useParkingZoneChangeCountry from 'hooks/useParkingZoneChangeCountry';
import useParkingZoneWithEVCheck from 'hooks/useParkingZoneWithEVCheck';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useActiveElementStore } from 'stores/activeElementStore';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import ChargerListing from './ChargerListing';

export const SelectCharger: React.FC = () => {
  const { t } = useTranslation();
  useParkingZoneChangeCountry();

  const parkZoneId = useActiveElementStore((state) => state.activeElement);

  const parkingZone = useParkingZoneWithEVCheck(
    parkZoneId,
    'cache-and-network',
    true
  );

  if (!parkingZone?.data?.parkZone?.uid) {
    return <></>;
  }

  const handleSelectCharger = (chargingStationId: string) => {
    useActiveElementStore
      .getState()
      .setActiveElementSecondaryUid(chargingStationId);
  };

  return (
    <>
      <ImportantZoneNotes />
      <>
        <ColumnWithMargins mt={15} mb={20} ml={20}>
          <Meta color={theme.colors.gray300}>
            {t('evCharging.selectCharger')}
          </Meta>
        </ColumnWithMargins>
        <ChargerListing
          parkZone={parkingZone.data.parkZone}
          onChargerSelection={handleSelectCharger}
          loading={parkingZone.loading}
        />
      </>
    </>
  );
};

export default SelectCharger;
